import axios from "axios";
import { useEffect, useState } from "react";
import { useRef } from "react";
import { AiOutlineDoubleLeft } from "react-icons/ai";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { BiSearch } from "react-icons/bi";
import "../TableAHSF/style.css";
import React from "react";
import PopupAHSF from "../PopupAHSF";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import loadConfig from "../../Services/Api/ApiServices";
import { decryptToken } from "../../Services/Encryption/EncryptionToken";
import { SetArrayDataCheckBoks } from "../../Redux/Reducers/Shared/CheckBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const TableAHSF = (props) => {
  const [options, setOptions] = useState(props.DropdownArrayFiltration);
  const [filterRefrish, setFilterRefrish] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [arrayButton, SetArrayButton] = useState(props.arrayButton);
  const [arrayNameDataColum, SetArrayNameDataColum] = useState(
    props.ArrayNameDataColum
  );
  const [stebPagination, setStebPagination] = useState(0);
  const [endpagination, setEndPagination] = useState(5);
  const [stateSort, setStateSort] = useState();
  // const [arrayDataCheckBoks, setArrayDataCheckBoks] = useState([]);
  const [halfPageNumber, setHalfPageNumber] = useState(5);
  const [res, setRes] = useState([]);
  const [total, setTotal] = useState([]);
  const [filterData, SetFilterData] = useState([]);
  const [refreshFilter, setRefreshFilter] = useState(false);
  const [valueFilterSupDropDown, SetvalueFilterSupDropDown] = useState("");
  const [hideDropDown, setHideDropDown] = useState("");
  const [loading, setLoading] = useState(true);
  const [openPopupState, setopenPopupState] = useState(props.openPopupState);
  const [isOpen, setIsOpen] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  ////////////////
  const [mainFiltration, setMainFiltration] = useState([]);
  const [jsonData, setJsonData] = useState({});
  const [jsonLoding, setJsonLoding] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]); // Track selected checkboxes
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setOptions(props.DropdownArrayFiltration);
  // }, [props.DropdownArrayFiltration]);

  const state = useSelector((state) => {
    return {
      refreshTableStatus: state.refreshTableStatus.refreshTable,
      arrayDataCheckBoks: state.arrayDataCheckBoks.arrayDataCheckBoks,
    };
  });

  const refresh = useSelector(
    (state) => state.refreshTableStatus.refreshTable[props.tableId]
  );

  const getJson = async () => {
    var json = await loadConfig();
    setJsonData(json);
    setJsonLoding(true);
  };

  const accessTokenFun = async () => {
    if (window.location.href.includes("manager")) {
      let accessToken = await decryptToken("AccessTokenManager", "manager");
      setAccessToken(accessToken);
    } else {
      let accessToken = await decryptToken("AccessToken", "sso");
      setAccessToken(accessToken);
    }
  };
  // console.log(valueFilterSupDropDown, "sdjkhsdjsjhd");

  useEffect(() => {
    // console.log(`${jsonData.domainUrl}/${props.URL}`, "malekgggggggggggg");

    accessTokenFun();

    getJson();
    setLoading(true);
    axios
      .post(`${jsonData.domainUrl}/${props.URL}`, props.UrlBody, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setRes(response.data.result);
        SetFilterData(response.data.result);
        setRefreshFilter(false);
        setLoading(false);
        // console.log(response.data, "tyutyus");
      })
      .catch((err) => {
        // console.log(err, "error");
        setLoading(false);
      });
    //////////////////////////////////////// handel check box List when next to page //////////////////////////////////////
    Array.from(document.getElementsByClassName("checkboxList")).map(
      (ele, ind) => {
        ele.checked = false;
      }
    );

    state?.arrayDataCheckBoks[props.uniqeKeyNameRedux]?.map((ele, ind) => {
      if (document.getElementById(ele.userGUID) !== null) {
        document.getElementById(ele.userGUID).checked = true;
      }
    });
    //////////////////////////////////////// End handel check box List when next to page //////////////////////////////////
  }, [filterRefrish, jsonLoding, state.refreshTableStatus, refresh]);
  ////////////////////////////////////////////////////////////////// handel dropDownfilteration
  useEffect(() => {
    // Helper function to filter unique objects based on specific properties
    function uniqueByProperties(arr, props) {
      return arr.filter(
        (obj, index, self) =>
          index ===
          self.findIndex((t) => props.every((prop) => t[prop] === obj[prop]))
      );
    }

    let array = []; // Initialize an empty array to hold transformed options
    // Loop through the 'res' array to extract dropdown options
    res.map((element) => {
      return props.accessor.map((element_) => {
        if (
          element_.DropdownFiltrationStatus &&
          element[element_.KeyName] != null
        ) {
          // console.log(element_, "sdsdddddddsdsd");
          // Push transformed dropdown option into the array
          array.push({
            label: element[element_.DropdownFiltration.keyTextName], // Display text
            value: element[element_.DropdownFiltration.keyValueName], // Option value
            keyName: element_.KeyName,
            keyValueName: element_.DropdownFiltration.keyValueName, // Value key
            groping: element_.NmaeColumn, // Grouping category
            // tableNameShow: "kkk",
          });
        }
      });
    });

    // Filter out any options with null values
    let filteredArray = array.filter((item) => item.value !== null);
    // Get unique objects based on 'value' and 'keyName' properties
    let uniqueObjects = uniqueByProperties(filteredArray, ["value", "keyName"]);
    setOptions(uniqueObjects);
  }, [res, props.accessor]);

  const handleCheckboxChange = (option, e) => {
    if (e.target.checked) {
      // Add the selected option
      setSelectedOptions((prev) => [
        ...prev,
        { key: option.keyValueName, value: option.value },
      ]);
    } else {
      // Remove the deselected option
      setSelectedOptions((prev) =>
        prev.filter(
          (selected) =>
            selected.key !== option.keyValueName ||
            selected.value !== option.value
        )
      );
    }
  };

  //   let props.dataRedux = res;

  //   const groupedOptions = selectedOptions.reduce((acc, { key, value }) => {
  //     if (!acc[key]) acc[key] = []; // Initialize group if not already present
  //     acc[key].push(value); // Add value to the corresponding group
  //     return acc;
  //   }, {});
  //   // Filter the data based on the selected options
  //   props.dataRedux = Object.entries(groupedOptions).reduce(
  //     (data, [key, values]) => {
  //       // Filter data where the key's value is included in the selected values
  //       return data.filter((option) => values.includes(option[key]));
  //     },
  //     props.dataRedux
  //   );

  // console.log(props.dataRedux, "props.dataRedux");

  ///////////////////////////////////////////////////////// end dropDownfilteration

  ///////////////////// customize search function /////////////////////////////////
  var arabicNormChar = {
    ك: "ک",
    ﻷ: "لا",
    ؤ: "و",
    ى: "ی",
    ي: "ی",
    ئ: "ی",
    أ: "ا",
    إ: "ا",
    آ: "ا",
    ٱ: "ا",
    ٳ: "ا",
    ة: "ه",
    ء: "",
    "ِ": "",
    "ْ": "",
    "ُ": "",
    "َ": "",
    "ّ": "",
    "ٍ": "",
    "ً": "",
    "ٌ": "",
    "ٓ": "",
    "ٰ": "",
    "ٔ": "",
    " ": "",
  };
  const simplifyArabic = (value) => {
    return value
      .replace(/[^\u0000-\u007E]/g, function (option) {
        var retval = arabicNormChar[option];

        if (retval == undefined) {
          retval = option;
        }
        return retval;
      })
      .normalize("NFKD")
      .toLowerCase();
  };

  /////////////////////////End customize search function ///////////////////////////////////////

  ///////////////////////////handel Search function to filter data table ////////////////////////
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setHideDropDown("hide");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handelSearch = (e) => {
    setRes(filterData);
    setRes(
      filterData.filter((opject, ind) => {
        console.log(opject, "obj");
        return simplifyArabic(Object.values(opject).join("")).includes(
          simplifyArabic(e.target.value)
        );
      })
    );
    console.log(filterData, "search");
  };

  //////////////////////////////////////////Sum column////////////////////////////////////////////////////
  const numberWithCommas = (x) => {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const calculatorColumn = (columnKeyName) => {
    console.log(columnKeyName, "sdssssssssxsdwdwdwd");

    let sum = 0;
    sum = res.reduce((accumulator, currentValue) => {
      console.log(currentValue[columnKeyName], "sdsdsdsdsddd");

      return accumulator + Number(currentValue[columnKeyName]);
    }, 0);
    return sum;
  };
  //////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////// ColumnsOperation function/////////////////////////
  const ColumnsOperation = (columnKeyNameArray) => {
    let sum = 0;

    columnKeyNameArray.map((keyNAme, ind) => {
      sum = res.reduce((accumulator, currentValue) => {
        return currentValue[keyNAme]
          ? accumulator + Number(currentValue[keyNAme])
          : 0;
      }, 0);
    });
    // console.log(numberWithCommas(sum), "sum");
    return numberWithCommas(sum);
  };
  ///////////////////////////////////////////End ColumnsOperation function/////////////////////////

  const tableRef = useRef(null);
  //////////////////////end function////////////////////////////////////////////////////////////

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const groupingDropDown = () => {
    const groupedOption = {};
    options.forEach((ele, ind) => {
      if (!groupedOption[ele.groping]) {
        groupedOption[ele.groping] = [];
      }
      groupedOption[ele.groping].push(ele);
    });

    return groupedOption;
  };

  // useEffect(() => {
  //   console.log(arrayDataCheckBoks, "arr");
  // }, [arrayDataCheckBoks]);
  // this line convert array of opject to array of string
  const keyNames = props.accessor.map((item) => item.KeyName);

  return (
    <>
      <div className="tableContainer" id={props.tableId}>
        {props.tableHeader != true ? (
          <div className="headTable">
            <div className="CenterSection">
              {/*
              لاظهار واخفاء زر الاضافة في اعلى الجدول 
               */}
              {props.tableBtn ? (
                <>
                  <button
                    onClick={() => {
                      setopenPopupState(true);
                    }}
                    className="tableBtn bi bi-plus-square-fill"
                  ></button>
                </>
              ) : (
                ""
              )}

              {/*
              عنوان الجدول 
               */}
              <h4 className="titelTable" title={props.titelTableTitle}>
                {props.lang !== "en" ? props.titelTable : props.titelTableEN}
              </h4>
            </div>

            <div className="rightSection">
              {/*
              قائمة الفلتر في اعلى الججول 
               */}
              {props.DropdownFiltration ? (
                <>
                  <div className="dropdown" ref={dropdownRef}>
                    <button
                      className="dropdown-toggle"
                      onClick={toggleDropdown}
                    >
                      اختر الخيارات
                    </button>
                    {isOpen && (
                      <div className="dropdown-content">
                        {Object.keys(groupingDropDown()).map((option, ind) => {
                          return (
                            <div
                              key={ind}
                              className="optionDropDownName"
                              onClick={() => {
                                // console.log(option, "sdsdwdwddsd");

                                SetvalueFilterSupDropDown(option);
                                setHideDropDown("");
                              }}
                            >
                              {option}
                            </div>
                          );
                        })}

                        <div className={`supDropDown ${hideDropDown}`}>
                          {[
                            ...new Map(
                              options.map((item) => [item.label, item])
                            ).values(),
                          ]
                            .filter(
                              (option) =>
                                option.groping === valueFilterSupDropDown
                            )
                            .map((option, ind) => (
                              <label key={ind}>
                                <div></div>
                                <input
                                  type="checkbox"
                                  id={`checkbox${ind}`}
                                  checked={selectedOptions.some(
                                    (selected) =>
                                      selected.value === option.value
                                  )}
                                  onChange={(e) => {
                                    handleCheckboxChange(option, e);
                                    // console.log(option, "sdjkijiwudiud");
                                  }}
                                />
                                {option.label}
                              </label>
                            ))}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}

              {props.search ? (
                <>
                  <div className="input-wrapper">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <input
                      id="searchInput"
                      // placeholder="بحث"
                      // placeholder="🔍 بحث"
                      placeholder={props.lang !== "en" ? "ابحث هنا" : "search"}
                      onChange={(e) => {
                        handelSearch(e);
                        setSearchValue(e.target.value);
                      }}
                      disabled={false}
                    />{" "}
                    {/* <label id="searchIcon">
                    <BiSearch />
                  </label> */}
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="bodyTable">
          <table>
            <thead className="head_table" dir="rtl">
              <tr>
                {props.checkBoks ? (
                  <th className="chexkBoxColum">{props.checkBoksColumName}</th>
                ) : (
                  ""
                )}

                {props.arrayButton.length > 0 ? (
                  <th id="actionColumn">{props.nameColumAction}</th>
                ) : (
                  <></>
                )}

                {props.accessor.map((ele, ind) => {
                  if (ele.ShowStatus) {
                    return props.sort ? (
                      props.arrayNameSort.includes(ele.NmaeColumn) ? (
                        <th>
                          {ele}{" "}
                          <label>
                            {stateSort === "Descending" ? (
                              // <TbSortAscending />
                              <></>
                            ) : (
                              // <PiSortAscendingFill />
                              <></>
                            )}
                          </label>
                        </th>
                      ) : (
                        <th>
                          {" "}
                          {props.lang !== "en"
                            ? ele.NmaeColumn
                            : ele.NmaeColumnEN}
                        </th>
                      )
                    ) : (
                      <th>
                        {" "}
                        {props.lang == "ar" ? ele.NmaeColumn : ele.NmaeColumnEN}
                      </th>
                    );
                  }
                })}

                {/* {props.checkBoks ? (
                  <th className="chexkBoxColum">{props.checkBoksColumName}</th>
                ) : (
                  ""
                )} */}
              </tr>
            </thead>

            <tbody>
              {
                /////////////////////////////////////////////////////////////////////////////////////////////////////
                <>
                  {
                    ///////////////////////////////////////////////////////////////////////////////////// هنا جزئية الكبسات الخاصة في عامود ال action
                    props.dataRedux &&
                      props.dataRedux
                        ?.slice(stebPagination, endpagination)
                        .map((elee, indMain) => {
                          // console.log(elee, "resssssssssss");

                          return (
                            <tr>
                              {props.checkBoks ? (
                                <td className="checkBoxColum">
                                  <input
                                    name={elee[props.uniqeKeyName]}
                                    className="checkboxList"
                                    type="checkbox"
                                    id={elee.userGUID}
                                    checked={state.arrayDataCheckBoks.some(
                                      (item) =>
                                        item[props.uniqeKeyName] ===
                                        elee[props.uniqeKeyName]
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        dispatch(
                                          SetArrayDataCheckBoks([
                                            ...state.arrayDataCheckBoks,
                                            elee,
                                          ])
                                        );
                                      } else {
                                        dispatch(
                                          SetArrayDataCheckBoks(
                                            state.arrayDataCheckBoks.filter(
                                              (item) =>
                                                item[props.uniqeKeyName] !==
                                                elee[props.uniqeKeyName]
                                            )
                                          )
                                        );
                                      }
                                    }}
                                  />
                                </td>
                              ) : (
                                ""
                              )}
                              {arrayButton && arrayButton.length > 0 ? (
                                <td className="actionButton">
                                  {arrayButton &&
                                    arrayButton.map((ele, ind) => {
                                      console.log(elee, "SDSDSDSDSDSD");

                                      if (ele.ShowStatus) {
                                        if (
                                          ele.ForSpecificLineStatus === true &&
                                          elee[ele.ForSpecificLineName] ==
                                            ele.ForSpecificLineId
                                        ) {
                                          return (
                                            <button
                                              value={
                                                elee[props.valueButtonAction]
                                              }
                                              onClick={ele.Click}
                                              id={ele.id}
                                              className={`buttonActionColumn ${ele.className}`}
                                            >
                                              {ele.content}{" "}
                                            </button>
                                          );
                                        } else if (
                                          elee[ele.ForSpecificLineName] ==
                                            "00000000-0000-0000-0000-000000000000" &&
                                          ele.id == "editBtn"
                                        ) {
                                          return <></>;
                                        } else if (!ele.ForSpecificLineStatus) {
                                          if (props.KeyCondition) {
                                            if (
                                              elee[props.KeyCondition] ==
                                              props.modelCondition[
                                                props.KeyCondition
                                              ]
                                            ) {
                                              if (
                                                props.btnNotToShow != ele.id
                                              ) {
                                                // console.log("resssssss");
                                                return (
                                                  <button
                                                    value={
                                                      elee[
                                                        props.valueButtonAction
                                                      ]
                                                    }
                                                    onClick={ele.Click}
                                                    id={ele.id}
                                                    className={`buttonActionColumn ${ele.className}`}
                                                  >
                                                    {ele.content}{" "}
                                                  </button>
                                                );
                                              }
                                            } else {
                                              return (
                                                <button
                                                  value={
                                                    elee[
                                                      props.valueButtonAction
                                                    ]
                                                  }
                                                  onClick={ele.Click}
                                                  id={ele.id}
                                                  className={`buttonActionColumn ${ele.className}`}
                                                >
                                                  {ele.content}{" "}
                                                </button>
                                              );
                                            }
                                          } else if (
                                            props.arrayButtonLastIndex
                                          ) {
                                            if (
                                              indMain ==
                                              props.dataRedux.length - 1
                                            ) {
                                              return (
                                                <button
                                                  value={
                                                    elee[
                                                      props.valueButtonAction
                                                    ]
                                                  }
                                                  onClick={ele.Click}
                                                  id={ele.id}
                                                  className={`buttonActionColumn ${ele.className}`}
                                                >
                                                  {ele.content}{" "}
                                                </button>
                                              );
                                            }
                                          } else {
                                            return (
                                              <button
                                                value={
                                                  elee[props.valueButtonAction]
                                                }
                                                onClick={ele.Click}
                                                id={ele.id}
                                                className={`buttonActionColumn ${ele.className}`}
                                              >
                                                {ele.content}{" "}
                                              </button>
                                            );
                                          }
                                        }
                                      }
                                    })}
                                </td>
                              ) : (
                                ""
                              )}
                              {/* ////////////////////////////////////////////end هنا جزئية الكبسات الخاصة في عامود ال action/////////////////////////////////////// */}

                              {/* ///////////////////////////////////////////////////هنا الجزئية الخاصة في الصفوف//////////////////////////////////// */}
                              {Object.entries(elee).map((ele, ind) => {
                                // console.log(ele, "llklklklkldsd");

                                return props.accessor.map((opject, ind) => {
                                  // console.log(ele, "sdsdsfsdfsdfsfdsdsd");

                                  if (
                                    opject.KeyName == ele[0] &&
                                    opject.ShowStatus
                                  ) {
                                    if (opject.comma) {
                                      return (
                                        <td className={`${ele[0]}`}>
                                          {numberWithCommas(ele[1])}
                                        </td>
                                      );
                                    } else if (
                                      ele[0] == props.dateKey ||
                                      ele[0] == props.dateKey2
                                    ) {
                                      return (
                                        <td className={`${ele[0]}`} dir="ltr">
                                          {moment(ele[1]).format(
                                            props.dateformat
                                          )}
                                        </td>
                                      );
                                    }
                                    if (
                                      opject.typeColumn == "file" &&
                                      ele[1] !== null
                                    ) {
                                      // console.log(ele[1], "sdasqwqwqwqwsdsd");

                                      return (
                                        <td className={`${ele[0]}`}>
                                          <Link
                                            target="_blank"
                                            className="AttachmentTable"
                                            to={
                                              jsonData.domainUrl +
                                              "/" +
                                              (ele[1].includes(
                                                "IDDocumentAttachment"
                                              )
                                                ? props.fileStoreName
                                                : ele[1].includes(
                                                    "CVDocumentAttachment"
                                                  )
                                                ? props.fileStoreName2
                                                : props.fileStoreName) +
                                              "/" +
                                              ele[1]
                                            }
                                          >
                                            <button class="open-file">
                                              <span class="file-wrapper">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  fill="none"
                                                  viewBox="0 0 71 67"
                                                >
                                                  <path
                                                    stroke-width="5"
                                                    stroke="black"
                                                    d="M41.7322 11.7678L42.4645 12.5H43.5H68.5V64.5H2.5V2.5H32.4645L41.7322 11.7678Z"
                                                  ></path>
                                                </svg>
                                                <span class="file-front"></span>
                                              </span>
                                            </button>
                                          </Link>
                                        </td>
                                      );
                                    } else {
                                      return (
                                        <td className={`${ele[0]}`}>
                                          {ele[1]}
                                        </td>
                                      );
                                    }
                                  }
                                });
                              })}
                              {/* ///////////////////////////////////////////////////////////////////////////////////////// */}
                              {/* {props.checkBoks ? (
                                <td className="checkBoxColum">
                                  {
                                    <input
                                      className="checkboxList"
                                      type="checkbox"
                                      id={elee.userGUID}
                                      onClick={(e) => {
                                        if (e.target.checked === true) {
                                          setArrayDataCheckBoks([
                                            ...arrayDataCheckBoks,
                                            elee,
                                          ]);
                                        } else if (e.target.checked === false) {
                                          setArrayDataCheckBoks(
                                            arrayDataCheckBoks.filter(
                                              (Element, index) => {
                                                return (
                                                  elee.userGUID !=
                                                  Element.userGUID
                                                );
                                              }
                                            )
                                          );
                                        }
                                      }}
                                    />
                                  }
                                </td>
                              ) : (
                                ""
                              )} */}
                            </tr>
                          );
                        })
                  }
                </>

                /////////////////////////////////////////////////////////////// end button action
              }
              {/* // هنا يتم احتساب المجموع */}
              {props.total ? (
                <tr id="total">
                  <td>المجموع</td>
                  {/*  */}

                  {
                    ///////////////////////////////////////////////////////////////////////////////////// هنا جزئية الكبسات الخاصة في عامود ال action
                    props.accessor.map((ele, ind) => {
                      return (
                        <td>
                          {props.columnKeyNameArray.map((elememnt, ind) => {
                            console.log(
                              ele.KeyName,
                              elememnt.keyName,
                              "sdsdsdsd"
                            );

                            return ele.TotalNumber
                              ? calculatorColumn(ele.KeyName)
                              : "";
                          })}
                        </td>
                      );
                    })
                  }
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
        {props.pagination ? (
          <div className="pagination">
            <div className="slectShowRow">
              {props.selectRowNumber ? (
                <select
                  onChange={(e) => {
                    setEndPagination(parseInt(e.target.value));
                    setHalfPageNumber(parseInt(e.target.value));
                    setStebPagination(0);
                  }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                  <option value={30}>30</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              ) : (
                ""
              )}

              {props.selectRpwNumber ? <label>عدد الصفوف الظاهرة</label> : ""}
            </div>

            <div className="rightSection">
              <button
                className="AiOutlineDoubleRight"
                onClick={() => {
                  if (stebPagination >= 5) {
                    setStebPagination(stebPagination - halfPageNumber);
                    setEndPagination(endpagination - halfPageNumber);
                  }
                }}
              >
                <AiOutlineDoubleRight />
              </button>
              <label>
                {props.lang !== "en" ? (
                  <label>
                    {" "}
                    صفحة {endpagination / halfPageNumber} - من{" "}
                    {Math.ceil(props.dataRedux.length / halfPageNumber)} صفحة
                  </label>
                ) : (
                  <label>
                    {" "}
                    page {endpagination / halfPageNumber} - from page
                    {Math.ceil(props.dataRedux.length / halfPageNumber)}
                  </label>
                )}
              </label>
              <button
                className="AiOutlineDoubleRight"
                onClick={() => {
                  if (endpagination <= props.dataRedux.length) {
                    setStebPagination(stebPagination + halfPageNumber);
                    setEndPagination(endpagination + halfPageNumber);
                  }
                }}
              >
                <AiOutlineDoubleLeft />
              </button>
            </div>

            <div className="leftSection"></div>
          </div>
        ) : (
          ""
        )}

        {props.paginationHide ? (
          <div className="pagination">
            <div className="rightSection">
              <button className="AiOutlineDoubleRight"></button>
            </div>

            <div className="leftSection"></div>
          </div>
        ) : (
          ""
        )}
      </div>
      {/*popup edite*/}
      <PopupAHSF
        idButton={props.PopupOPjectData.idButton}
        isPopupOpenStatus={openPopupState}
        isPopupOpenFunction={() => {
          setopenPopupState(false);
        }}
        title={props.PopupOPjectData.title}
        componentBody={props.PopupOPjectData.componentBody}
        maxWidth={props.PopupOPjectData.maxWidth}
        maxHeight={props.PopupOPjectData.maxHeight}
      />
      {/*popup details*/}
      {props.popUpBody}
      {/* <PopupAHSF isPopupOpenStatus={props.openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={props.title} componentBody={props.componentBody} maxWidth={props.maxWidth} maxHeight={props.maxHeight} /> */}
      {/*popup popup_1*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_2*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_3*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_4*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
      {/*popup popup_5*/}
      {/* <PopupAHSF isPopupOpenStatus={openPopupState} isPopupOpenFunction={() => { setopenPopupState(false) }} title={"ssss"} componentBody={<></>} maxWidth={"500px"} maxHeight={"800px"} /> */}
    </>
  );
};

export default TableAHSF;
